export default __webpack_public_path__ + "static/media/logo.1819a4eb.webp";